<template>
  <el-dialog class="demand_model_dialog" top="5vh" center title="转交工单" width="85%" :before-close="handleClose"
             :visible.sync="dialogVisible" :append-to-body="true" :close-on-click-modal="false">
    <el-form v-loading="loading.dialog" size="mini" ref="form" :rules="rules" :model="form">
      <div style="display: flex;">
        <el-form-item label="受理人" prop="acceptor_id" :label-width="formLabelWidth">
          <el-select size="mini"  v-model="form.acceptor_id" filterable placeholder="请选择">
            <el-option v-for="(key, value) in allUserList.ALLUSERTYPE1" :key="key" :label="key" :value="value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="级别" prop="level" :label-width="formLabelWidth">
          <el-select size="mini"   v-model="form.level" filterable placeholder="请选择">
            <el-option v-for="(key, value) in workOrderConfig.LEVEL" :key="key" :label="key" :value="value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="分类" prop="classify" :label-width="formLabelWidth">
          <el-select size="mini"   v-model="form.classify" filterable placeholder="请选择">
            <el-option v-for="(key, value) in NewworkOrderConfig" :key="key.value" :label="key.value" :value="key.key">
            </el-option>
          </el-select>
          <el-tooltip class="item" effect="dark" content="新增分类" placement="top">
            <span @click="dialogVisibleAddCateGory = true"  class="el-icon-plus addCategory">新增分类</span>
          </el-tooltip>
        </el-form-item>
      </div>
      <el-form-item label="备注" prop="note" :label-width="formLabelWidth">
        <el-input type="textarea"  :autosize="{ minRows: 6, maxRows: 16 }"
                  placeholder="请输入备注" v-model="form.note">
        </el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button  type="warning"  :loading="loading.submit"  @click="onSubmit()">转 交</el-button>
      <el-button type="success" @click="handleClose">关 闭</el-button>
    </div>
    <el-dialog center :append-to-body="true" title="新增分类" :visible.sync="dialogVisibleAddCateGory" width="40%">
      <el-form :model="categoryForm" :rules="categoryRules" ref="categoryForm" >
        <el-form-item label="分类名称" prop="module_value" label-width="72px" >
          <el-input  v-model="categoryForm.module_value" autocomplete="off">
          </el-input>
        </el-form-item>
        <div style="margin:0 auto;text-align: center">
          <el-button size="small" type="primary" @click="onAddCateGory" :loading="loading.addCategoryLoad">确 定</el-button>
          <el-button size="small" @click="dialogVisibleAddCateGory = false">取 消</el-button>
        </div>
      </el-form>
    </el-dialog>
  </el-dialog>
</template>
<script>
import { Editor } from "@/components/index.js";
import { formatEnToUtf8 } from "@/views/tops/devOps/components/util.js"

import {
  getDevOpsSpaceProducerListApi, postDevOpsSpaceClaimWorkOrderApi, postDevOpsSpaceCreateSystemApi
} from "@/server/tops/devOps";
import { mapState } from "vuex";
import {getDevOpsSpaceAllUserListApi, getDevOpsSpaceWorkOrderConfigApi} from "@/server/tops/base";
export default {
  components: {Editor},
  props: {
    formInfo: {
      type: Object,
      default: function () {
        return {}
      },
    },
    dialogVisible: {
      type: Boolean,
      default: function () {
        return false
      }
    },
    hideDialogVisible: {
      type: Function,
      default: function () {
        return () => { }
      }
    },
    showDialogVisible: {
      type: Function,
      default: function () {
        return () => { }
      }
    },
  },
  data() {
    return {
      form: {
        level: '',
        classify:'',
        note:'',
        acceptor_id: '',
      },

      rules: {
        level: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        classify: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        acceptor_id: {
          required: true,
          message: "必填",
          trigger: "blur",
        }
      },
      formLabelWidth: '135px',
      chainingLink: true,
      chainingLinkTo: true,
      loading: {
        dialog: false,
        submit: false,
        addCategoryLoad: false,
      },
      userNameInfo:'',
      dialogVisibleAddCateGory: false,
      categoryForm:{
        module_value:'',
        work_type:'6',
      },
      categoryRules:{
        module_value: {
          required: true,
          message: "必填",
          trigger: "blur",
        }
      },
      NewworkOrderConfig:{},
    };
  },
  async mounted() {
    const { id = '',level='',classify='', state_code = ''} = this.formInfo;
    const username = this.$store.state.devOps.userInfo.devops_name? this.$store.state.devOps.userInfo.devops_name : '';
    const username_cn = this.$store.state.devOps.userInfo.user_name_zh? this.$store.state.devOps.userInfo.user_name_zh : '';
    this.form = { ...this.form, workId:id, work_state:state_code,level,classify}
    this.$set(this.form, 'username', username)
    this.username = username;
    this.userNameInfo = username_cn + '('+username+')';
    if(this.$store.state.devOps.userInfo.userId){
      this.userId = this.$store.state.devOps.userInfo.userId;
    }
    //获取未开始，进行中的项目
    this.$nextTick(async () => {
      await this.getWorkOrderConfig();
    })
    this.NewworkOrderConfig = this.workOrderConfig.CATEGORY
  },
  computed: {
    ...mapState(
        {
          allSelect: (state) => state.devOps.ALLSELECT,
          allSystem: (state) => state.devOps.ALLSYSTEM,
          allUserList: (state) => state.devOps.ALLUSERLIST,
          workOrderConfig: (state) => state.devOps.WORKORDERCONFIG,
        }
    ),
  },
  methods: {
    onSubmit(){
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          try {
            this.$set(this.loading, 'submit', true)
            await postDevOpsSpaceClaimWorkOrderApi({...this.form,type:'2'}).then((ret)=>{
              if (ret.status === 'success') {
                this.$notify({
                  message: ret.message || '提交成功',
                  type: "success",
                })
                setTimeout(() => {
                  this.handleClose()

                }, 500)
              } else {
                this.loading.submit = false;
                this.$notify({
                  message: ret.message || "失败",
                  type: "error",
                })
              }
            })
          }catch (error) {
            this.loading.submit = false;
            this.$notify({
              message: error || "网络错误",
              type: "error",
            })
          }finally {
            this.loading.submit = false;
          }

        }
      });

    },
    // 关闭弹窗
    handleClose(step) {
      this.hideDialogVisible(step)
    },
    getNowDate(){
      var today = new Date();
      var year = today.getFullYear();//获取年份
      var month = today.getMonth() + 1;//获取月份
      var day = today.getDate();//获取日期
      let cmonth = month < 10 ? '0'+month : month;
      let cday = day < 10 ? '0' + day : day;
      let h = today.getHours() < 10 ? '0'+today.getHours() : today.getHours();
      let m = today.getMinutes() < 10 ? '0'+today.getMinutes() : today.getMinutes();
      let s = today.getSeconds() < 10 ? '0'+today.getSeconds() : today.getSeconds();
      return year + "-" + cmonth + "-" + cday + " " + h + ":" + m + ":" + s;
    },
    onAddCateGory(){
      this.$refs["categoryForm"].validate(async (valid) => {
        if (valid) {
          try {
            this.$set(this.loading, 'addCategoryLoad', true);
            const ret =  await postDevOpsSpaceCreateSystemApi(this.categoryForm);
            if (ret.status === 'success') {
              this.dialogVisibleAddCateGory = false;
              this.loading.addCategoryLoad =  false;
              await this.getWorkOrderConfig();
              this.$notify({
                message: ret.message || "成功",
                type: "success",
              })
            } else {
              this.loading.addCategoryLoad =  false;
              this.$notify({
                message: ret.message || "失败",
                type: "error",
              })
            }
          } catch (error) {
            this.loading.addCategoryLoad =  false;
            this.$notify({
              message: error || "网络错误",
              type: "error",
            })
          } finally {
            this.loading.addCategoryLoad =  false;
          }
        }

      })
    },
    async getWorkOrderConfig() {
      await getDevOpsSpaceWorkOrderConfigApi({type: '6'}).then((res) => {
        let category = [];
        res.data.forEach((item, index) => {
          category.push({key:item.key,value:item.value});
        });
        this.NewworkOrderConfig = category;
      })
    },
    getDate(){
      var today = new Date();
      var year = today.getFullYear();//获取年份
      var month = today.getMonth() + 1;//获取月份
      var day = today.getDate();//获取日期
      let cmonth = month < 10 ? '0'+month : month;
      let cday = day < 10 ? '0' + day : day;
      return year + "-" + cmonth + "-" + cday;
    },
    // 将多个英文名转换为中文
    formatEnToUtf8,
  }
};
</script>
<style lang="scss">
.demand_model_dialog {
  .table_text_click {
    text-decoration: underline;
    color: #409EFF;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
  .table_text_click_new {
    text-decoration: underline;
    color: #409EFF;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
  }
  .table_text_no_click {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }

  .el-dialog__body {
    padding-bottom: 0;
  }
  .addCategory{
    margin-left: 2px;
    color: rgb(64, 158, 255);
    cursor: pointer;
    border: 1px solid;
    padding: 5px 10px;
    border-radius: 10px;
    font-size: 12px;
  }
}

</style>
